import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  prefixCurriculumName,
  setSubChildId,
} from "Administrator/modules/AdministratorModule";
import { EVALUATION_CRITERIA_SETTINGS } from "Constants/stringConstants";
export default store => ({
  path: "settings",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([import("./components")]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    const state = store.getState();
    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );
    const childId = store.dispatch(
      prefixCurriculumName({
        childId: EVALUATION_CRITERIA_SETTINGS,
        curriculumProgramId,
      })
    );
    store.dispatch(setSubChildId(childId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
